import userAgentIdentifiers from "../constants/userAgentIdentifiers";

const isWindowsApp = () => navigator.userAgent === userAgentIdentifiers.WINDOWS_APP;

const isMacApp = () =>
  navigator.userAgent === userAgentIdentifiers.MAC_APP || navigator.userAgent === userAgentIdentifiers.MAC_SCREENSHOT;

const isIosApp = () =>
  navigator.userAgent === userAgentIdentifiers.IOS_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_MOBILE_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_12_MOBILE_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_TABLET_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_12_TABLET_APP ||
  navigator.userAgent === userAgentIdentifiers.MOBILE_SCREENSHOT ||
  navigator.userAgent === userAgentIdentifiers.TABLET_SCREENSHOT;

const isIosMobileApp = () =>
  navigator.userAgent === userAgentIdentifiers.IOS_MOBILE_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_12_MOBILE_APP ||
  navigator.userAgent === userAgentIdentifiers.MOBILE_SCREENSHOT;

const isIosTabletApp = () =>
  navigator.userAgent === userAgentIdentifiers.IOS_TABLET_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_12_TABLET_APP ||
  navigator.userAgent === userAgentIdentifiers.TABLET_SCREENSHOT;

const isIos12App = () =>
  navigator.userAgent === userAgentIdentifiers.IOS_12_MOBILE_APP ||
  navigator.userAgent === userAgentIdentifiers.IOS_12_TABLET_APP;

const isScreenshotApp = () =>
  navigator.userAgent === userAgentIdentifiers.MAC_SCREENSHOT ||
  navigator.userAgent === userAgentIdentifiers.TABLET_SCREENSHOT ||
  navigator.userAgent === userAgentIdentifiers.MOBILE_SCREENSHOT;

const isUnknownApp = () => !isWindowsApp() && !isMacApp() && !isIosApp() && !isScreenshotApp();

export default {
  isWindowsApp,
  isMacApp,
  isIosApp,
  isIosMobileApp,
  isIos12App,
  isIosTabletApp,
  isUnknownApp,
  isScreenshotApp
};
